class ComparisonSection extends HTMLElement {
  products = [];
  connectedCallback() {
    this.dropdown = this.querySelector("[data-compare-toggle]");
    this.item = this.querySelectorAll("[data-item]")[1]
    this.dropdown.addEventListener("change", this.fetchProduct.bind(this));
  }
  fetchProduct() {
    this.item.classList.add("loading");
    try {
      const handle = this.dropdown.value;
      fetch(`/products/${handle}?view=comparison`)
        .then((res) => res.text())
        .then((res) => {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(res, "text/html");
          console.log(htmlDoc,this.item)
          this.item.innerHTML = htmlDoc.querySelector('[data-item]').innerHTML
        })
        .catch((err) => {
          this.item.classList.remove("loading");
        })
        .finally(() => {
          this.item.classList.remove("loading");
        });
    } catch (e) {
      this.item.classList.remove("loading");
    }
  }
  removeProduct(value) {
    const options = Array.from(this.dropdown.querySelectorAll("option"));

    options.forEach((opt) => {
      if (opt.value === value) {
        if (!this.products.some((p) => p.handle === value)) {
          this.products.push({
            handle: value,
            title: opt.textContent,
          });
        }
        opt.remove();
      }
    });
    if (options.length < 2) {
      this.controls.remove();
    }
  }
  // Element functionality written in here
}
document.addEventListener("DOMContentLoaded", function () {
  customElements.define("product-compare", ComparisonSection);
});
